// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 737) return "static/chunks/fb7d5399-bc13912e5249d83f.js";
	if (chunkId === 228) return "static/chunks/252f366e-c1e94604a14034f0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"282":"bdb3ea2b05c4cade","798":"4b5ce6b439afd096","824":"6d303b477f2e8cf2","844":"88f7b2e0787bbaba"}[chunkId] + ".js";
};